<template>
  <div class="mx-auto w-full max-w-7xl px-5 sm:px-8">
    <slot />
  </div>
</template>
